'use es6';

const DEFAULT_CACHE_SIZE = 200;
export default class VersionedDomElementCache {
  constructor({
    cacheSizeLimit = DEFAULT_CACHE_SIZE
  } = {}) {
    this.cacheSizeLimit = cacheSizeLimit;
    this.cache = {};
    this.recentlyTouchedItems = [];
  }
  setCacheSize(newSize) {
    this.cacheSizeLimit = newSize;
    this._sweepCache();
  }
  addCacheEntry(name, version, domElement) {
    if (!this.cache[name]) {
      this.cache[name] = [];
    }
    this.cache[name][version] = domElement;
    this.touchCacheEntry(name, version);
  }
  getCacheEntry(name, version) {
    return this.itemIsInCache(name, version) ? this.cache[name][version] : null;
  }
  touchCacheEntry(name, version) {
    if (!this.itemIsInCache(name, version)) {
      // Like unix, touching a cache entry that doesn't exist will create one (can be overriden later by adding a new entry to the same name / version path)
      if (!this.cache[name]) {
        this.cache[name] = [];
      }
      this.cache[name][version] = null;
    }
    this._removeItemFromRecentlyTouchedItems(name, version);
    this.recentlyTouchedItems.unshift({
      name,
      version
    });
    this._sweepCache();
  }
  removeCacheEntry(name, version) {
    if (this.cache[name]) {
      delete this.cache[name][version];
      if (!this.cache[name].length) {
        delete this.cache[name];
      }
    }
    this._removeItemFromRecentlyTouchedItems(name, version);
  }
  removeCacheEntryVersionsAboveSpecificVersion(name, versionToStartDeletingFrom) {
    if (this.cache[name]) {
      const versionEntrySize = this.cache[name].length;
      for (let i = versionToStartDeletingFrom; i < versionEntrySize; i++) {
        this.removeCacheEntry(name, i);
      }
    }
  }
  itemIsInCache(name, version) {
    return !!this.cache[name] && !!this.cache[name][version];
  }
  getCacheSize() {
    let size = 0;
    Object.keys(this.cache).forEach(name => {
      this.cache[name].forEach(version => {
        if (version !== undefined) {
          size = size + 1;
        }
      });
    });
    return size;
  }
  getRecentlyTouchedEntries() {
    return this.recentlyTouchedItems;
  }
  _sweepCache() {
    while (this.recentlyTouchedItems.length > this.cacheSizeLimit) {
      const {
        name,
        version
      } = this.recentlyTouchedItems.pop();
      if (this.cache[name]) {
        delete this.cache[name][version];
      }
      if (!this.cache[name].length) {
        delete this.cache[name];
      }
    }
  }
  _removeItemFromRecentlyTouchedItems(name, version) {
    const existingRecentlyTouchedIndex = this.recentlyTouchedItems.findIndex(entry => entry.name === name && entry.version === version);
    if (existingRecentlyTouchedIndex > -1) {
      this.recentlyTouchedItems.splice(existingRecentlyTouchedIndex, 1);
    }
  }
}